<template>
    <app-main>
        <app-content>

            <div class="flex flex-wrap -mx-2">
                <div class="w-full md:w-1/2 px-2">
                    <!-- Start Title -->
                    <app-title
                        title="Services"
                        sub-title="Editing a service draft"
                    />
                    <!-- End Title -->
                </div>
                <div class="w-full md:w-1/2 px-2 md:text-right">
                     <app-button element="a" class="btn  btn--primary  btn--primary--sml" @click="save">
                        Accept
                    </app-button>

                    <app-button v-if="service" element="a" class="btn  btn--secondary  btn--secondary--sml ml-4" @click="$router.push({ name: 'services.home' })">
                        Cancel
                    </app-button>
                </div>
            </div>

            <app-tabs-wrapper default="general" :loading="loading" :initial="loading" class="mb-8">
                <div class="w-full flex items-center border-b-2 border-grey-lighter" slot-scope="{ toggle, active }">
                    <app-tabs-trigger name="general" :handle-click="toggle" :active="active">General</app-tabs-trigger>
                    <app-tabs-trigger name="content" :handle-click="toggle" :active="active">Content</app-tabs-trigger>
                    <app-tabs-trigger name="locations" :handle-click="toggle" :active="active" v-if="!autino">Locations</app-tabs-trigger>
                    <app-tabs-trigger name="seo" :handle-click="toggle" :active="active">SEO &amp; Search</app-tabs-trigger>
                </div>

                <div slot="items" slot-scope="{ active }">
                    <app-tabs-content name="general" :active="active">
                        <app-field-select
                            :required="true"
                            label="Locale"
                            :items="items.locales"
                            v-model="fields.locale_id"
                            preselect="&mdash; Please select &mdash;"
                            :error="errors.locale_id"
                        />

                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-text
                                    :required="true"
                                    label="Title"
                                    v-model="fields.title"
                                    :error="errors.title"
                                />
                            </div>
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-text
                                    :required="true"
                                    label="Slug"
                                    v-model="fields.slug"
                                    :error="errors.slug"
                                />
                            </div>
                        </div>

                        <app-field-toggle
                            :required="false"
                            label="Published?"
                            v-model="fields.published"
                            :error="errors.published"
                        />

                        <app-field-datetime
                            :required="false"
                            label="Published At"
                            v-if="fields.published"
                            v-model="fields.published_at"
                            :error="errors.published_at"
                        />
                    </app-tabs-content>
                    <app-tabs-content name="content" :active="active">
                        <app-field-category
                            :required="true"
                            label="Primary Category"
                            v-model="fields.category_id"
                            :error="errors.category_id"
                            :items="mappedCategories"
                        />

                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-text
                                    :required="false"
                                    label="Price Copy"
                                    v-model="fields.from_copy"
                                    :error="errors.from_copy"
                                />
                            </div>
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-currency
                                    :required="true"
                                    label="Price"
                                    v-model="fields.from_price"
                                    :error="errors.from_price"
                                />
                            </div>
                        </div>

                        <app-field-trix
                            :required="false"
                            label="Description"
                            v-model="fields.description"
                            :error="errors.description"
                        />

                        <app-field-trix
                            :required="false"
                            label="Benefit"
                            v-model="fields.benefit"
                            :error="errors.benefit"
                        />

                         <div class="flex flex-wrap -mx-2">
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-file
                                    :required="false"
                                    label="Thumbnail"
                                    v-model="fields.thumbnail"
                                    :error="errors.thumbnail"
                                    helper="Maximum width: 750px"
                                    :types="{images: true, files: false}"
                                />
                            </div>
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-file
                                    :required="false"
                                    label="Image"
                                    v-model="fields.image"
                                    :error="errors.image"
                                    helper="Maximum width: 750px"
                                    :types="{images: true, files: false}"
                                />
                            </div>
                        </div>

                        <app-field-repeatable
                            :required="false"
                            label="Features"
                            placeholder="Feature item"
                            v-model="fields.checklist"
                            :error="errors.checklist"
                        />
                    </app-tabs-content>
                    <app-tabs-content name="locations" :active="active" v-if="!autino">
                        <app-table v-if="items.locations.length > 0">
                            <app-table-header>
                                <app-table-row :header="true">
                                    <app-table-cell :header="true">
                                        <strong>Location</strong>
                                    </app-table-cell>
                                    <app-table-cell class="text-center" :header="true">
                                        <strong>Price</strong>
                                    </app-table-cell>
                                    <app-table-cell class="text-center" :header="true">
                                        <strong>Published / Enabled</strong>
                                    </app-table-cell>
                                </app-table-row>
                            </app-table-header>

                            <app-table-body>
                                <app-table-row v-for="(l, i) in items.locations" :key="i">
                                    <app-table-cell v-html="l.name" />
                                    <app-table-cell class="text-center">
                                        <app-field-currency
                                            :required="true"
                                            v-model="fields.config[l.id].price"
                                            :error="errors.price"
                                            :classes="{ wrapper: { 'reset': true } }"
                                        />
                                    </app-table-cell>
                                    <app-table-cell class="text-center">
                                        <app-field-toggle
                                            :required="false"
                                            v-model="fields.config[l.id].published"
                                            :error="errors.published"
                                            :classes="{ wrapper: { 'reset': true } }"
                                        />
                                    </app-table-cell>
                                </app-table-row>
                            </app-table-body>
                        </app-table>
                    </app-tabs-content>
                    <app-tabs-content name="seo" :active="active">
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-repeatable
                                    :required="false"
                                    label="Keywords (for searching)"
                                    placeholder="Enter a keyword"
                                    v-model="fields.keywords"
                                    :error="errors.keywords"
                                />
                            </div>
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-repeatable
                                    :required="false"
                                    label="Phrases (for searching)"
                                    placeholder="Enter a phrase"
                                    v-model="fields.phrases"
                                    :error="errors.phrases"
                                />
                            </div>
                        </div>

                        <app-field-text
                            :required="false"
                            label="Meta Title"
                            v-model="fields.meta_title"
                            :error="errors.meta_title"
                        />

                        <app-field-textarea
                            :required="false"
                            label="Meta Description"
                            v-model="fields.meta_desc"
                            :error="errors.meta_desc"
                            rows="4"
                        />

                        <app-seo-widget :title="fields.meta_title" :description="fields.meta_desc" :slug="fields.slug" />
                    </app-tabs-content>
                </div>
            </app-tabs-wrapper>
        </app-content>
    </app-main>
</template>

<script>
    import { mapGetters } from 'vuex';
    /* API */
    import Api from '@/api/index.js';
    import Auth from '@/api/auth.js';
    /* Components */
    import Main from '@/components/Main';
    import Content from '@/components/template/Content';
    import Title from '@/components/Title';
    import Box from '@/components/Box';
    import Button from '@/components/Button';
    import SelectField from '@/components/fields/inputs/Select';
    import TextField from '@/components/fields/inputs/Text';
    import CategoryField from '@/components/fields/inputs/Category';
    import ToggleField from '@/components/fields/inputs/Toggle';
    import TextareaField from '@/components/fields/inputs/Textarea';
    import DateTimeField from '@/components/fields/inputs/DateTime';
    import TrixField from '@/components/fields/inputs/Trix';
    import CurrencyField from '@/components/fields/inputs/Currency';
    import RepeatableField from '@/components/fields/inputs/Repeatable';
    import FileField from '@/components/fields/inputs/File';
    import TabsWrapper from '@/components/tabs/Wrapper';
    import TabsTrigger from '@/components/tabs/Trigger';
    import TabsContent from '@/components/tabs/Content';
    import SEO from '@/components/SEO';

    /* Mixins */
    import ValidationErrors from '@/mixins/validationErrors.js';

    export default {
        name: 'services.edit',

        data: () => ({
            service: null,
            fields: {
                locale_id: '',
                category_id: '',
                title: '',
                slug: '',
                description: '',
                benefit: '',
                from_copy: 'Now only',
                from_price: '',
                thumbnail: '',
                image: '',
                checklist: [],
                keywords: [],
                phrases: [],
                meta_title: '',
                meta_desc: '',
                published: false,
                published_at: '',
                config: {}
            },
            items: {
                locales: [],
                categories: [],
                locations: [],
            },
            loading: false,
            errors: {}
        }),

        components: {
            'app-main': Main,
            'app-content': Content,
            'app-title': Title,
            'app-box': Box,
            'app-button': Button,
            'app-field-select': SelectField,
            'app-field-text': TextField,
            'app-field-category': CategoryField,
            'app-field-toggle': ToggleField,
            'app-field-textarea': TextareaField,
            'app-field-datetime': DateTimeField,
            'app-field-trix': TrixField,
            'app-field-currency': CurrencyField,
            'app-field-repeatable': RepeatableField,
            'app-field-file': FileField,
            'app-tabs-wrapper': TabsWrapper,
            'app-tabs-trigger': TabsTrigger,
            'app-tabs-content': TabsContent,
            'app-seo-widget': SEO
        },

        mixins: [
            ValidationErrors
        ],

        mounted() {
            if (typeof this.$route.params.id != 'undefined') {
                this.loading = true;

                this.getCategories()
                    .then(response => {
                        this.getService(this.$route.params.id)
                            .then(response => {
                                this.loading = false;

                                this.setLocales();

                                for (let index in this.service) {
                                    if (typeof this.fields[index] !== 'undefined') {
                                        switch (index) {
                                            case "published_at":
                                                if(this.service[index] != null) {
                                                    this.fields[index] = this.service[index].split(' ').join('T') + '.000Z';
                                                }
                                                break;

                                            default:
                                                this.fields[index] = this.service[index];
                                        }
                                    }
                                }
                            })
                            .catch(error => {
                                this.$router.push({name: 'services.home'});
                            });
                    })
                    .then(response => {
                        this.loading = false;
                    });
            } else {
                this.$router.push({name: 'services.home'});
            }
        },

        computed: {
            ...mapGetters({
                locales: 'locales/items'
            }),

            mappedCategories() {
                return this.items.categories.length > 0 ? this.items.categories.map((item) => {
                    return {
                        name: item.name,
                        icon: item.svg,
                        value: item.id
                    }
                }) : [];
            }
        },

        methods: {
            getCategories() {
                return Api.request('get', `services/categories`)
                    .then(({ data }) => {
                        this.items.categories = data.categories;
                    });
            },
            getService(id) {
                return Api.request('get', `services/edit/${id}`)
                    .then(({ data }) => {
                        this.service = data.service;
                    });
            },
            save() {
                this.loading = true;
                this.clearErrors();

                return Api.request('post', `services/update/${this.service.id}`, this.fields).then(response => {
                    if(typeof response.data.message != 'undefined') {
                        this.$toasted.show(response.data.message, {
                            type: "success",
                            position: "bottom-right",
                            duration : 5000
                        });
                    }
                    if(typeof response.data.id != 'undefined') {
                        this.$router.push({
                            name: 'services.home'
                        });
                    }
                }).catch(error => {
                    if(this.hasErrors(error)) {
                        this.addErrors(error);
                    }
                }).then(response => {
                    this.loading = false;
                });
            },
            setLocales() {
                if (this.locales.length > 0) {
                    this.locales.forEach(locale => {
                        this.items.locales.push({
                            label: locale.lang,
                            value: locale.id
                        });
                    });
                }
            }
        },

        watch: {
            'fields.title': {
                handler(val) {
                    this.fields.slug = val.toString().toLowerCase()
                        .replace(/\s+/g, '-')           // Replace spaces with -
                        .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
                        .replace(/\-\-+/g, '-')         // Replace multiple - with single -
                        .replace(/^-+/, '')             // Trim - from start of text
                        .replace(/-+$/, '');            // Trim - from end of text
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/services/View.vue